import { render } from "./ClassroomProgramDialog.vue?vue&type=template&id=46f6b1f3"
import script from "./ClassroomProgramDialog.vue?vue&type=script&lang=js"
export * from "./ClassroomProgramDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__